// extracted by mini-css-extract-plugin
export var infoBox = "style-module--infoBox--f0b50";
export var infoBox__close = "style-module--infoBox__close--d6f8f";
export var infoBox__container = "style-module--infoBox__container--ac4a7";
export var infoBox__logo = "style-module--infoBox__logo--f778d";
export var infoBox__main = "style-module--infoBox__main--cd2c0";
export var infoBox__rightFloat = "style-module--infoBox__rightFloat--cebff";
export var infoBox__text = "style-module--infoBox__text--69ff5";